/* Flash FAQ page: topic chips, search with highlight, accordion, deep links, sticky search bar. */
(function () {
  'use strict';

  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function esc(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  function norm(s) { return (s || '').toLowerCase().replace(/[‘’]/g, "'").replace(/[“”]/g, '"').replace(/\s+/g, ' ').trim(); }

  function highlight(el, re) {
    if (el.__orig === undefined) el.__orig = el.innerHTML;
    el.innerHTML = el.__orig;
    if (!re) return;
    var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach(function (node) {
      var text = node.nodeValue;
      re.lastIndex = 0;
      if (!re.test(text)) return;
      re.lastIndex = 0;
      var frag = document.createDocumentFragment();
      var last = 0, m;
      while ((m = re.exec(text))) {
        if (m.index > last) frag.appendChild(document.createTextNode(text.slice(last, m.index)));
        var mark = document.createElement('mark');
        mark.textContent = m[0];
        frag.appendChild(mark);
        last = m.index + m[0].length;
        if (m[0].length === 0) re.lastIndex++;
      }
      if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
      node.parentNode.replaceChild(frag, node);
    });
  }

  function setOpen(item, open) {
    var q = item.querySelector('[data-fq-q]');
    var a = item.querySelector('[data-fq-a]');
    if (!q || !a) return;
    q.setAttribute('aria-expanded', open ? 'true' : 'false');
    a.hidden = !open;
  }

  function init(root) {
    if (!root || root.__fq) return;
    root.__fq = true;

    var cats = $$(document, '[data-fq-cat]');
    var chipsEl = root.querySelector('[data-fq-chips]');
    var input = root.querySelector('[data-fq-input]');
    var clearBtn = root.querySelector('[data-fq-clear]');
    var form = root.querySelector('[data-fq-form]');
    var status = root.querySelector('[data-fq-status]');
    var empty = root.querySelector('[data-fq-empty]');
    var termEl = root.querySelector('[data-fq-term]');
    var slot = root.querySelector('[data-fq-slot]');
    var bar = root.querySelector('[data-fq-bar]');
    var note = root.querySelector('[data-fq-editor-note]');
    var tOne = root.getAttribute('data-t-one') || 'question matches';
    var tMany = root.getAttribute('data-t-many') || 'questions match';
    var current = null;

    if (note) note.hidden = cats.length > 0;

    /* Index every question */
    var items = [];
    cats.forEach(function (cat, ci) {
      cat.__key = 'c' + ci;
      $$(cat, '[data-fq-item]').forEach(function (item) {
        var q = item.querySelector('[data-fq-text]');
        var a = item.querySelector('[data-fq-a]');
        items.push({ el: item, cat: cat, q: q, a: a, text: norm((q ? q.textContent : '') + ' ' + (a ? a.textContent : '')) });
      });
    });

    /* Chips */
    function chip(key, label, count) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'fgs-fq-chip';
      b.setAttribute('role', 'tab');
      b.setAttribute('data-fq-chip', key);
      b.setAttribute('aria-selected', key === current ? 'true' : 'false');
      b.appendChild(document.createTextNode(label + ' '));
      var s = document.createElement('span');
      s.textContent = count;
      b.appendChild(s);
      return b;
    }
    cats.some(function (cat) { if ($$(cat, '[data-fq-item]').length) { current = cat.__key; return true; } return false; });
    function buildChips() {
      if (!chipsEl) return;
      chipsEl.innerHTML = '';
      cats.forEach(function (cat) {
        var n = $$(cat, '[data-fq-item]').length;
        if (n) chipsEl.appendChild(chip(cat.__key, cat.getAttribute('data-fq-cat-title') || '', n));
      });
    }
    function selectChip(key) {
      current = key;
      $$(chipsEl, '[data-fq-chip]').forEach(function (b) {
        b.setAttribute('aria-selected', b.getAttribute('data-fq-chip') === key ? 'true' : 'false');
      });
    }
    function showTopic(key) {
      cats.forEach(function (cat) { cat.hidden = cat.__key !== key; });
    }
    function scrollToList() {
      if (!slot) return;
      var head = headerHeight();
      var y = slot.getBoundingClientRect().top + window.pageYOffset - head;
      if (window.pageYOffset > y) window.scrollTo(0, y);
    }

    buildChips();
    showTopic(current);

    if (chipsEl) {
      chipsEl.addEventListener('click', function (e) {
        var b = e.target.closest('[data-fq-chip]');
        if (!b) return;
        var key = b.getAttribute('data-fq-chip');
        if (input && input.value) { input.value = ''; runSearch(); }
        selectChip(key);
        showTopic(key);
        b.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        scrollToList();
      });
    }

    /* Search */
    var timer;
    function runSearch() {
      var raw = input ? input.value : '';
      var query = norm(raw);
      if (clearBtn) clearBtn.hidden = !raw;
      var terms = query.split(' ').filter(function (t) { return t.length > 0; });
      var active = query.length >= 2;
      var re = active ? new RegExp('(' + terms.map(esc).join('|') + ')', 'gi') : null;
      var hits = 0;
      var perCat = {};

      items.forEach(function (it) {
        var match = !active || terms.every(function (t) { return it.text.indexOf(t) !== -1; });
        it.el.hidden = !match;
        if (it.q) highlight(it.q, match ? re : null);
        if (it.a) highlight(it.a, match ? re : null);
        if (match) { hits++; perCat[it.cat.__key] = (perCat[it.cat.__key] || 0) + 1; }
      });

      cats.forEach(function (cat) {
        var n = perCat[cat.__key] || 0;
        var countEl = cat.querySelector('[data-fq-cat-count]');
        if (countEl) countEl.textContent = active ? n : $$(cat, '[data-fq-item]').length;
        cat.hidden = active ? n === 0 : cat.__key !== current;
      });

      items.forEach(function (it) { if (!it.el.hidden) setOpen(it.el, active && hits <= 3); });
      if (!active) items.forEach(function (it) { setOpen(it.el, false); });

      if (chipsEl) $$(chipsEl, '[data-fq-chip]').forEach(function (b) {
        b.setAttribute('aria-selected', !active && b.getAttribute('data-fq-chip') === current ? 'true' : 'false');
      });
      if (active) {
        if (status) { status.hidden = hits === 0; status.textContent = hits + ' ' + (hits === 1 ? tOne : tMany); }
        if (empty) { empty.hidden = hits !== 0; if (termEl) termEl.textContent = raw.trim(); }
      } else {
        if (status) status.hidden = true;
        if (empty) empty.hidden = true;
      }
    }
    if (input) {
      input.addEventListener('input', function () { clearTimeout(timer); timer = setTimeout(runSearch, 120); });
      input.addEventListener('focus', scrollToList);
    }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); if (input) input.blur(); runSearch(); });
    if (clearBtn) clearBtn.addEventListener('click', function () { input.value = ''; runSearch(); input.focus(); });

    /* Sticky search bar (the topics are separate sections, so CSS sticky can't span them) */
    function headerHeight() {
      var h = document.querySelector('.shopify-section-group-header-group');
      var inner = h && h.firstElementChild;
      var el = inner || h;
      if (!el) return 0;
      var r = el.getBoundingClientRect();
      var pos = window.getComputedStyle(el).position;
      if (pos !== 'fixed' && pos !== 'sticky') return 0;
      return Math.max(0, Math.round(r.bottom));
    }
    function setVar(name, val) {
      root.style.setProperty(name, val);
      cats.forEach(function (c) { c.style.setProperty(name, val); });
    }
    function onScroll() {
      if (!slot || !bar) return;
      var head = headerHeight();
      setVar('--fq-head', head + 'px');
      var fixed = slot.getBoundingClientRect().top <= head;
      if (fixed && !bar.classList.contains('is-fixed')) {
        slot.style.height = bar.offsetHeight + 'px';
        bar.classList.add('is-fixed');
      } else if (!fixed && bar.classList.contains('is-fixed')) {
        bar.classList.remove('is-fixed');
        slot.style.height = '';
      }
      setVar('--fq-bar', (fixed ? bar.offsetHeight : 0) + 'px');
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      if (bar && slot && !bar.classList.contains('is-fixed')) slot.style.height = '';
      onScroll();
    });
    onScroll();

    /* Open the question in the URL, e.g. /pages/faq#hotspot */
    function openFromHash() {
      var id = decodeURIComponent((location.hash || '').slice(1));
      if (!id) return;
      var target = document.getElementById(id);
      if (!target) return;
      var item = target.matches('[data-fq-item]') ? target : null;
      var cat = item ? item.closest('[data-fq-cat]') : (target.matches('[data-fq-cat]') ? target : null);
      if (!cat) return;
      if (input && input.value) { input.value = ''; runSearch(); }
      selectChip(cat.__key);
      showTopic(cat.__key);
      if (item) { setOpen(item, true); item.classList.add('is-target'); }
      setTimeout(function () {
        target.scrollIntoView({ block: 'start' });
        onScroll();
        target.scrollIntoView({ block: 'start' });
      }, 60);
    }
    openFromHash();
    window.addEventListener('hashchange', openFromHash);
  }

  /* Accordion + shareable links (one listener for the whole page) */
  if (!window.__fgsFqClick) {
    window.__fgsFqClick = true;
    document.addEventListener('click', function (e) {
      var q = e.target.closest && e.target.closest('[data-fq-q]');
      if (!q) return;
      var item = q.closest('[data-fq-item]');
      var open = q.getAttribute('aria-expanded') !== 'true';
      setOpen(item, open);
      if (open && item.id && history.replaceState) history.replaceState(null, '', '#' + item.id);
    });
  }

  function boot() { $$(document, '[data-fgs-faq]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();

  /* Theme editor: rebuild when sections change */
  document.addEventListener('shopify:section:load', function () {
    $$(document, '[data-fgs-faq]').forEach(function (r) { r.__fq = false; init(r); });
  });
  document.addEventListener('shopify:section:unload', function () {
    setTimeout(function () { $$(document, '[data-fgs-faq]').forEach(function (r) { r.__fq = false; init(r); }); }, 0);
  });
})();
